/**
 * Partner configuration for white-label branding.
 *
 * Add new partners here with their slug, display name, logo, and feature flag.
 */

import { IS_WHITE_LABEL_R1_ENABLED } from '@/features/flags/legacy-flags';

export interface PartnerConfig {
  /** URL slug (e.g., "r1" for /p/r1) */
  slug: string;
  /** Display name shown in UI */
  name: string;
  /** Path to logo in public folder */
  logoUrl: string;
  /** Feature flag check function - returns true if partner is enabled for current user */
  isEnabled: () => boolean;
}

/**
 * Map of partner slugs to their configuration.
 */
export const PARTNERS: Record<string, PartnerConfig> = {
  r1: {
    slug: 'r1',
    name: 'R1',
    logoUrl: '/assets/logos/partners/r1-logo.png',
    isEnabled: () => IS_WHITE_LABEL_R1_ENABLED() ?? false,
  },
  // Phare Health - always enabled (no feature flag required)
  phare: {
    slug: 'phare',
    name: 'Phare Health',
    logoUrl: '/assets/logos/partners/phare-health.png',
    isEnabled: () => true,
  },
};

/**
 * Get partner config by slug.
 * Returns undefined if partner not found.
 */
export function getPartnerBySlug(slug: string): PartnerConfig | undefined {
  return PARTNERS[slug.toLowerCase()];
}

/**
 * Check if a slug is a valid partner.
 */
export function isValidPartner(slug: string): boolean {
  return slug.toLowerCase() in PARTNERS;
}

/**
 * Check if a partner is enabled for the current user (via feature flag).
 */
export function isPartnerEnabled(slug: string): boolean {
  const partner = getPartnerBySlug(slug);
  return partner?.isEnabled() ?? false;
}
